import { render } from "./edit_material.vue?vue&type=template&id=0f299f70"
import script from "./edit_material.vue?vue&type=script&lang=js"
export * from "./edit_material.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__